export default class EventIds {
  constructor(rawEvent) {
    this.rawEvent = rawEvent;
  }

  get id() {
    if (this.source.numericSourceId) {
      return this.rawEvent.source_id_s + this.source.suffix;
    }

    return this.rawEvent.objectID + this.source.suffix;
  }

  sourceFromEventId(eventId) {
    let source;
    const suffix = eventId[eventId.length - 1];
    if (suffix.match(/[0-9]/)) {
      return 'evvnt';
    }

    Object.keys(this.sources).forEach((key) => {
      if (this.sources[key] && this.sources[key].suffix == suffix) {
        source = key;
      }
    });

    return source;
  }

  hasNumericId(source) {
    return this.sources[source].numericSourceId;
  }

  get source() {
    return this.sources[this.rawEvent.sources[0]];
  }

  get sources() {
    return {
      evvnt: { suffix: '', numericSourceId: true },
      migration: { suffix: 'm', numericSourceId: true },
      geotix: { suffix: 'x', numericSourceId: true },
      enmotive: { suffix: 'e', numericSourceId: false },
      goldstar: { suffix: 'g', numericSourceId: true },
      ticketmaster: { suffix: 't', numericSourceId: false },
      bandsintown: { suffix: 'n', numericSourceId: true },
      eventbrite: { suffix: 'b', numericSourceId: true },
      axs: { suffix: 's', numericSourceId: true },
      active_network: { suffix: 'a', numericSourceId: false },
      run_sign_up: { suffix: 'r', numericSourceId: true },
      ticket_sign_up: { suffix: 'u', numericSourceId: true },
      event_vesta: { suffix: 'v', numericSourceId: true },
      ticket_fairy: { suffix: 'f', numericSourceId: true },
      race_entry: { suffix: 'c', numericSourceId: true },
    };
  }
}
